module.exports = __webpack_public_path__ + "img/ic_launcher@3x.88d23086.png";